import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SimpleToast from '../SimpleToast.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderCancelledToast',
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleToast, {
    variant: "success",
    "icon-name": "tick-circle-bulk",
    title: "modules.myOrders.toasts.cancelled.title",
    message: "modules.myOrders.toasts.cancelled.message",
    onRemove: _cache[0] || (_cache[0] = ($event: any) => (emit('remove')))
  }))
}
}

})